module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAq0lEQVRYR+2Xyw2AIAxAW+fQIY0DqAMYh9Q5xHjgIAIRSrUk5V54ef0FBCEHhXCAgriZkG3ErJ3hrB3st4cArxFxID5yLlNRIwpitdsaUSPVGCnV1slzxA2QA7K0E2mONDhe8WQjJAgAiHXjpwMtGwQOM1Ms4LDfUpkPQqHw1EK9IEQRwfBkIwrCZcC9V1NDNlJquYVSnrxruGrnNQgXQOxe2T89NfKHAffNE7s1gyM75Ww+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/seven.png
// module id = Paxr
// module chunks = 1